import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5bd48942"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "scroll-wrap"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://weijl.top/",
  width: "600px",
  height: "600px"
}, null, -1));

const _hoisted_3 = [_hoisted_2];
import { onMounted } from "vue";
import IntroductionPanel from '@/components/home/IntroductionPanel.vue';
export default {
  __name: 'HomePage',

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }

};